let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8JZKd")).then(() => parcelRequire('g8im1'));